"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFaceSolanaNearTransactionPayload = void 0;
function parseFaceSolanaNearTransactionPayload(arg) {
    if (arg == null || typeof arg !== 'object') {
        return null;
    }
    if (arg['serializedHex'] == null || typeof arg['serializedHex'] !== 'string') {
        return null;
    }
    return arg;
}
exports.parseFaceSolanaNearTransactionPayload = parseFaceSolanaNearTransactionPayload;
//# sourceMappingURL=face-event.js.map